import { render } from "./FridgeCoolingAssistPage.vue?vue&type=template&id=cb80a876&scoped=true&ts=true"
import script from "./FridgeCoolingAssistPage.vue?vue&type=script&lang=ts"
export * from "./FridgeCoolingAssistPage.vue?vue&type=script&lang=ts"

import "./FridgeCoolingAssistPage.vue?vue&type=style&index=0&id=cb80a876&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb80a876"]])

export default __exports__